<template>
  <div v-bind:class="getClass()">
    <div class="mdgridviewpage-bg">
      <!-- <HeaderProfile></HeaderProfile> -->
      <!-- Page Content -->
      <div class="container-fluid">
        <div class="row">
          <div class="col-lg-12"></div>
        </div>
      </div>
      <div class="container-fluid m-t-10px">
        <div class="row dashboardchart-container globalconfigcontainer">
          <div class="col-lg-8" style="margin:0 auto;"></div>
        </div>
      </div>
      <div class="container-fluid">
        <div class="row">
          <div class="col-lg-12">
            <div class="card mainCard mt-3">
              <h4 class="color-white f-w-100 mb-3">
                <!-- <span class="border-bottom-white">Upload Your Data</span> -->
                <span class="">Change Password</span>
              </h4>
              <div class="card-body p-0 ">
                <div class="d-flex bg-white row">
                  <form class="col-12">
                    <div class="form-group m-4">
                      <div class="row mb-3">
                        <div class="col-3">
                          <label for="uname" class="">Username  <span class="text-danger">*</span></label>
                        </div>
                        <div class="col-9">
                          <input type="text" class="form-control" placeholder="" id="uname" autocomplete="new-nemail@DFHRFDRDF" v-model="frmModel.username" disabled>
                        </div>
                      </div>
                      <div class="row mb-3">
                        <div class="col-3">
                          <label for="oldPassword" class="">Old Password  <span class="text-danger">*</span></label>
                        </div>
                        <div class="col-9">
                          <input type="password" class="form-control" placeholder="" id="oldPassword" autocomplete="old-password" v-model="oldPassword">
                        </div>
                      </div>
                      <div class="row mb-3">
                        <div class="col-3">
                          <label for="newPassword" class="">New Password  <span class="text-danger">*</span></label>
                        </div>
                        <div class="col-9">
                          <input type="password" class="form-control" placeholder="" id="newPassword" autocomplete="new-paaaassword" v-model="newPassword">
                        </div>
                      </div>
                      <div class="row mb-3">
                        <div class="col-3">
                          <label for="r_newPassword" class="">Repeat New Password  <span class="text-danger">*</span></label>
                        </div>
                        <div class="col-9">
                          <input type="password" class="form-control" placeholder="" id="r_newPassword" autocomplete="new-rpassword" v-model="confirmPassword">
                        </div>
                      </div>
                      <div class="row mt-5">
                        <div class="col-12 text-right">
                          <button type="button" class="btn btn-primary" @click="updatePassword">Update Password</button>
                        </div>
                      </div>
                    </div>

                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <modals-container/>
    </div>
  </div>
</template>

<script>
  // import "vue-form-wizard/dist/vue-form-wizard.min.css";
  import ApiServices from '../service/ApiServices';

  import HeaderProfile from '../components/layout/HeaderProfile';
  import moment from 'moment';
  import swal from 'sweetalert2';
  window.Swal = swal;
  export default {
    components: {
        HeaderProfile
    },
    data() {
      return {
        disabled: 0,
        loggedInUserProfile: null,
        frmModel: {color : "#212832", username: ""},
        oldPassword: '',
        newPassword: '',
        confirmPassword: ''
      }
    },
    created() {

    },
    methods: {
      getClass(){
        // if(settings.countryName.toLowerCase() === 'nepal'){
        //   return 'newBlack-theme'
        // }else{
        //   return 'newBlue-theme'
        // }
        if(this.frmModel.color === '#212832'){
          return 'newBlack-theme'
        }else if(this.frmModel.color === '#66e093'){
          return 'newBlue-theme'
        }else if(this.frmModel.color === '#25984b'){
          return 'newGreen-theme'
        }
      },
      updatePassword(){
        this.$root.loading = true
        // console.log(this.oldPassword, this.newPassword, this.confirmPassword)
        if(this.newPassword === this.confirmPassword){
          ApiServices.RestPutCall('api/29/me/changePassword',{oldPassword: this.oldPassword, newPassword: this.newPassword}).then(Response =>{
            console.log(Response)
            Swal.fire({
              text: "Password updated successfully!",
              icon: 'warning',
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33'
            })
            this.$root.loading = false;
          }).catch(error=>{
            this.$root.loading = false;
            Swal.fire({
                text: "Password must not be one of the previous 24 passwords",
                icon: 'warning',
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33'
              })
          })
        }else{
          this.$root.loading = false;
           Swal.fire({
            text: "New Password and Confirm Password not matching",
            icon: 'warning',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33'
          })
        }

      }
    },
    mounted() {
      if(localStorage.getItem("userProfile")){
        this.loggedInUserProfile = JSON.parse(localStorage.getItem("userProfile"));
        this.frmModel.color = this.frmModel.color;
        this.frmModel.username = this.loggedInUserProfile.username;
      }
    }
  };
</script>

<style lang="scss" scoped>
.mdgridviewpage-bg {
  // background-color: #38a1c1;
  background-color: #3471CE;
  // background: url("../assets/img/blue-bg.jpg") no-repeat;
  background-size: cover;
  background-position: center;
  min-height: 100vh;
  padding: 0px 40px;
}

body.green-theme .mdgridviewpage-bg {
  background-color: #006600;
  background: url("../assets/img/green-bg.jpg") no-repeat;
  background-size: cover;
  background-position: center;
  min-height: 100vh;
  padding: 20px 40px;
}

.mainform-holder {
  background: #fff;
  -webkit-box-shadow: -2px 0px 5px 0px rgba(204, 204, 204, 1);
  -moz-box-shadow: -2px 0px 5px 0px rgba(204, 204, 204, 1);
  box-shadow: -2px 0px 5px 0px rgba(204, 204, 204, 1);
  border-radius: 10px;
  padding: 60px;
}

.homepage-bg {
        /*background: url("../assets/img/home/Avenir-health-home.jpg") no-repeat;*/
        background-image: linear-gradient(0deg, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url("../assets/img/home/avenirbg.jpg");
        background-repeat: no-repeat;
        background-size: cover;
        background-position: center;
    }

    .socialicons-container {
        position: absolute;
    }
    /*.config-icon-container {
  width: 100px;
  height: auto;
}*/

    .modRadio .config-icon-container {
        width: 100px;
        height: 100px;
    }

    #benchmarking .tabs .card-header {
        background-color: rgba(0, 0, 0, 0.03)
    }

    #sidebar-wrapper {
        position: relative
    }

    .modRadio.colorSelect {
        margin-bottom: 30px;
    }

    .overlay {
        position: absolute;
        top: 48px;
        left: 0;
        height: calc(100% - 126px);
        width: 100%;
        z-index: 10;
        background-color: rgba(0, 0, 0, 0.5);
    }

    .edit-links {
        z-index: 14;
        position: relative;
        color: #fff;
        font-size: 14px;
    }
    .img-preview img {
        width: 180px !important;
        margin-top: 20px;
    }
    .headingText {
        background: transparent;
        border: none;
        font-size: 2.5rem;
        font-weight: 100;
        font-color: #FFFFFF;
        padding: 0px;
    }

    .landing-desc {
        background: transparent;
        color: #fff;
        border: none;
        width: 100%;
    }
.col-form-label{
  font-size: 14px;
}
.vue-form-wizard .wizard-btn{
  font-weight: 400;
}
.card{
  background-color: #f4f4f4;
}
.col-lg-1, .col-lg-10, .col-lg-11, .col-lg-12, .col-lg-2, .col-lg-3, .col-lg-4, .col-lg-5, .col-lg-6, .col-lg-7, .col-lg-8, .col-lg-9, .col-md-1, .col-md-10, .col-md-11, .col-md-12, .col-md-2, .col-md-3, .col-md-4, .col-md-5, .col-md-55, .col-md-6, .col-md-7, .col-md-8, .col-md-9, .col-sm-1, .col-sm-10, .col-sm-11, .col-sm-12, .col-sm-2, .col-sm-3, .col-sm-4, .col-sm-5, .col-sm-6, .col-sm-7, .col-sm-8, .col-sm-9, .col-xs-1, .col-xs-10, .col-xs-11, .col-xs-12, .col-xs-2, .col-xs-3, .col-xs-4, .col-xs-5, .col-xs-6, .col-xs-7, .col-xs-8, .col-xs-9{
      padding-right: 15px !important;
    padding-left: 15px !important;
}
  select{
    -moz-appearance:none; /* Firefox */
    -webkit-appearance:none; /* Safari and Chrome */
    appearance:none;
    -moz-appearance:none !important;


  }
  .select-wrapper {
    position: relative;
  }

  .select-wrapper:after {
    font-family: FontAwesome;
      content: '\f0d7';
      font-size: 16px;
      position: absolute;
      top: 8px;
      right: 14px;
      color: #676767;
      pointer-events: none;
  }

  .bg-light-purple{
    background-color: #3662a8 !important;
  }
  .nav-tabs {
    display: none;
    height: 80vh;
    background: #373a3f !important;
  }
.mainCard{
  height: 80vh;
  border: 0;
}
.insidecard{
    height: 75vh;
    overflow: hidden;
    overflow-y: scroll;
}

.nav-tabs .nav-item{
  margin-bottom: 0;
}

.nav-tabs > li > a, .nav-tabs > li > a > .fa{
  font-size: 1.3em;
  color: #f4f4f4;
}
.nav-tabs .nav-item.show .nav-link, .nav-tabs .nav-link.active .fa{
  color: #4c4c4c;
}
label{
  margin-bottom: 0;
  font-size: 15px;
  padding-top: 14px;
  color: #4c4c4c;
  font-weight: 400;
}
.btn{
  font-size: 14px;
}
input[type="date"] {
  position: relative;
  padding: 10px;
}

input[type="date"]::-webkit-calendar-picker-indicator {
  color: transparent;
  background: none;
  z-index: 1;
}

input[type="date"]:before {
  color: transparent;
  background: none;
  display: block;
  font-family: 'FontAwesome';
  content: '\f073';
  /* This is the calendar icon in FontAwesome */
  width: 15px;
  height: 20px;
  position: absolute;
  top: 10px;
  right: 10px;
  color: #c2c3c3;
  cursor: pointer;
}

.newGreen-theme{
  .nav-tabs{
    background-color: #1a4728 !important;
  }
  .nav-tabs .nav-link.active{
    background-color: #fff;
  }
  .card{
    background-color: #fff;
  }
  .nav-tabs .nav-link.active:hover{
    background-color: #fff;
  }
}
@media (min-width: 768px) {
  .nav-tabs {
    display: flex;
    flex-flow: column nowrap;
  }
  .nav-tabs {
    border-bottom: none;
    border-right: 1px solid #ddd;
    display: flex;
  }
  .nav-tabs {
    margin: 0 0px 0 0;
  }
  // .nav-tabs .nav-item + .nav-item {
  //   margin-top: 0.25rem;
  // }
  .nav-tabs .nav-link {
    transition: border-color 0.125s ease-in;
    white-space: nowrap;
  }
  .nav-tabs .nav-link:hover {
    background-color: #d4d4d4;
    border-color: transparent;
    border-radius: 0;
    color: #4c4c4c !important;
    border-left: 6px solid #fe5868;
  }
  .nav-tabs .nav-link.active {

    border-radius: 0;
    background-color: #fff;
    border: 0;
    border-left: 6px solid #fe5868;
    font-weight: 500;
  }
  .nav-tabs #tab-A:hover{
    border-left: 6px solid #80b853;
  }
  .nav-tabs #tab-A.active{
    border-left: 6px solid #80b853;
  }
  .nav-tabs .nav-link.active:hover {
    background-color: #f4f4f4;

    // border-color: #0275d8 #fff #0275d8 #0275d8;

  }


}

@media (max-width: 767px) {
  .tab-pane {
    display: block !important;
    opacity: 1;
  }
}
::-webkit-scrollbar-thumb {
    border-radius: 4px;
    background-color: #c2c3c3;
    -webkit-box-shadow: 0 0 1px rgba(255, 255, 255, 0.5);
}
// .formInputs::after
// {
//   font-family: 'FontAwesome';
//   content: "\f007";
//   color:red;
//   position: relative;
//   left: -5px;

// }
.formInputs {
    position: relative;
  }

  // .formInputs:after {

  //   font-family: FontAwesome;
  //   content: '\f040';
  //   font-size: 12px;
  //   position: absolute;
  //   top: 13px;
  //   right: 10px;
  //   color: #676767;
  //   pointer-events: none;
  //   opacity: .6;

  // }
.editIcon{
  font-size: 12px;
    position: absolute;
    top: 13px;
    right: 10px;
    color: #676767;
    opacity: .6;
  display: none;

}

.form-control:hover ~ .editIcon{

    display: block;
}
.form-control:disabled ~ .editIcon{
  opacity: 0;
}
.select-wrapper .formInputs .editIcon {
  right: 35px;
}
.dobField .editIcon{
  top : 15px;
  right: 45px;
}
.form-control{
  font-size: 14px;
}

</style>
